module.exports = __webpack_public_path__ + "static/media/MostDazzlingGirlinBerlin.24ff86ef.jpg";